var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { MobileBasePage } from './mobile-base-page';
import { Injector, OnDestroy, OnInit } from '@angular/core';
import { DiscountManager, OrderItem } from 'aigens-ng-core';
import { SdkWeChatPayService } from '../services/sdk-wechat-pay-service';
import { SdkAlipayHKService } from '../services/sdk-alipay-hk-service';
import { SdkNativeOepayService } from '../services/sdk-native-oepay-service';
import { SdkApplepayService } from '../services/sdk-applepay-service';
import { DatePipe } from '@angular/common';
import { NetspayManager } from '../managers/netspayManager';
import { getDateStringLabel, getDeliveryDelayTime, getPickupDelayTime, getTandCUrl, getTodayMillisecondsFromTimeString, isAvailableOffer, isPeriodClosed, timeStringLabel } from '../../shared/utilities/checkFormatTool';
import { ByodSummaryPage } from '../../routes/summary/byod-summary/byod-summary';
import { UnlockPopupDialog } from '../../dialogs/unlockPopup/unlockPopup';
import { TermsConditionsPage } from '../../dialogs/terms-conditions/terms-conditions';
import { RouteTable } from '../route-table';
import { OfferListDialog } from '../../dialogs/offer-list/offer-list';
var BaseCartPage = /** @class */ (function (_super) {
    __extends(BaseCartPage, _super);
    // variables not in use
    // addInfo: any;
    function BaseCartPage(injector) {
        var _this = _super.call(this, injector) || this;
        _this.BKMember = {};
        // upselling variables
        _this.upSellItems = [];
        _this.hasRecommendation = false;
        _this.orderQueue = 0;
        _this.invalidAddress = false;
        _this.payments = [];
        _this.offers = [];
        _this.showPassCode = false;
        _this.wrong = false;
        _this.isPromoCodeFalse = false;
        _this.enableCoupon = false;
        _this.now = new Date().getTime();
        // points feature
        _this.pointFeature = false;
        _this.userTotalPoints = 0;
        _this.pointBasis = 10;
        _this.selectedPoint = 0;
        _this.points = [];
        _this.usablePoints = 0;
        _this.canPointsFullPay = false;
        _this.isPointFullPay = false;
        _this.pointPayment = null;
        _this.isPayByPoint = false;
        _this.showedBox = false;
        _this.discountManager = injector.get(DiscountManager);
        _this.sdkWeChatPayService = injector.get(SdkWeChatPayService);
        _this.sdkAlipayHKService = injector.get(SdkAlipayHKService);
        _this.sdkNativeOepayService = injector.get(SdkNativeOepayService);
        _this.sdkApplePayService = injector.get(SdkApplepayService);
        _this.datePipe = injector.get(DatePipe);
        _this.orderManager.setSeats(_this.orderService.seats);
        _this.orderManager.order.usedPoints = 0;
        _this.orderManager.pointsFactor = 0;
        _this.orderManager.calculate();
        _this.settingPickupTimeDisplay();
        _this.store = _this.orderManager.store;
        _this.order = _this.orderManager.getOrder();
        _this.pointFeature = _this.store && _this.store['crm'] && _this.store['crm']['addPoints'] && _this.store['crm']['pointToMoneyRatio'] !== 0 || false;
        console.log('om', _this.orderManager);
        _this.payments = _this.orderManager.store.brand['payments'];
        console.log('TCL: BaseCartPage -> constructor -> this.orderManager.getOrder', _this.orderManager.getOrder());
        _this.settingUpSelling();
        _this.settingPickupTime();
        _this.checkModifiableItems();
        // set source
        _this.orderManager.setSource('mobile');
        // this.addInfo = Store.getPickUpInfo(this.orderManager.store);
        var host = window.location.host;
        var isByod2 = host === 'internal-byod-test2.firebaseapp.com';
        if (_this.systemConfigService.enableCoupon) {
            _this.enableCoupon = true;
        }
        else if (isByod2) {
            _this.enableCoupon = true;
        }
        console.log(_this.orderManager.order);
        // init point pay
        if (_this.pointFeature) {
            var charge = (_this.store && _this.store.menu && _this.store.menu.serviceCharge) || 0;
            console.log('charge:', charge);
            if (_this.payments) {
                for (var _i = 0, _a = _this.payments; _i < _a.length; _i++) {
                    var p = _a[_i];
                    if (p['method'] === 'point') {
                        _this.pointPayment = p;
                        // this.canPointsFullPay = this.pointPayment['upperLimit'] > this.order.grandTotal && charge === 0;
                        break;
                    }
                }
            }
        }
        return _this;
    }
    BaseCartPage.prototype.getBKMember = function (callback) {
        var _this = this;
        if (this.orderService.session) {
            this.orderService.getBKUserInfo(this.orderService.session).subscribe(function (member) {
                _this.BKMember = member;
                if (callback) {
                    callback();
                }
                // console.log('jadd BKMember:', member);
            });
        }
    };
    BaseCartPage.prototype.getCrmPointRatio = function () {
        if (this.store && this.store.crm) {
            return this.store.crm.pointRatio;
        }
        else {
            return 0.1;
        }
    };
    BaseCartPage.prototype.popLogin = function () {
        if (this.orderService.courtId) {
            this.pushByName('LoginCourtPage', {
                courtId: this.orderService.courtId,
                features: this.orderService.courtBrand.features,
                brand: this.orderService.courtBrand,
                country: this.getCourtCountry(),
                fromCart: true,
            }, { relativeTo: this.route.root.firstChild });
        }
        else {
            this.pushByName('LoginPage', { store: this.store, fromCart: true }, { relativeTo: this.route.root.firstChild });
        }
    };
    BaseCartPage.prototype.getPointPaymentAmount = function () {
        return this.orderManager.order.usedPoints / this.orderManager.pointsFactor;
    };
    BaseCartPage.prototype.getDeliveryDelayTime = function (store) {
        return getDeliveryDelayTime(store);
    };
    BaseCartPage.prototype.getPickupDelayTime = function (store) {
        return getPickupDelayTime(store);
    };
    BaseCartPage.prototype.settingPickupTime = function () {
        var date = new Date();
        date = new Date(date.getTime() + (this.orderManager.mode === 'delivery' ? getDeliveryDelayTime(this.orderManager.store) : getPickupDelayTime(this.orderManager.store)) * 60000);
        var min = date.getMinutes();
        if (min >= 45) {
            date.setHours(date.getHours() + 1);
            date.setMinutes(0);
        }
        else if (min >= 30) {
            date.setMinutes(45);
        }
        else if (min >= 15) {
            date.setMinutes(30);
        }
        else {
            date.setMinutes(15);
        }
        if (date.getTime() > getTodayMillisecondsFromTimeString(this.timelabel)) {
            this.orderService.pickUpLabel = null;
            if (!this.orderService.isCourt) {
                this.orderService.pickUpTime = null;
            } // 如果是court pickupTime采取页面开始时选择的Time
        }
        this.timelabel = this.orderService.pickUpLabel ? this.orderService.pickUpLabel : this.getDefaultTimeLabel();
        this.pickedTimeNum = getTodayMillisecondsFromTimeString(this.timelabel);
        this.minPickUpTime = date;
        this.minPickUpTime.setSeconds(0, 0);
        var closeTime = this.orderService.maxPickupTime;
        this.maxPickUpTime = new Date();
        this.maxPickUpTime.setHours(Number(closeTime.split(':')[0]), Number(closeTime.split(':')[1]), 0);
        if (this.minPickUpTime.getHours() - this.maxPickUpTime.getHours() > 12) {
            this.maxPickUpTime = new Date(this.maxPickUpTime.getTime() + 24 * 60 * 60000);
        }
        // if (this.orderService.isBK) {
        //     this.timelabel = this.timeStringLabel(this.minPickUpTime.getTime());
        //     this.pickedTimeNum = date.getTime();
        //     this.orderService.pickUpTime = this.getDateStringLabel(Number(this.pickedTimeNum)) + "T" + this.timelabel + ":00.000";
        //     this.orderService.pickUpLabel = this.timelabel;
        // }
    };
    BaseCartPage.prototype.timeSelectAlert = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params, input, buttons, tempTime, timelabel, m, alert;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.googleAnalyticEventTrack('time box');
                        params = { backdropDismiss: false };
                        input = [];
                        buttons = [];
                        params['header'] = this.t.instant('global.please-select-alert-title');
                        tempTime = this.minPickUpTime;
                        if (this.systemConfigService.hidePickUpTimeDefault) {
                            // do nothing
                        }
                        else {
                            input.push({
                                type: 'radio',
                                label: this.getDefaultTimeLabel(),
                                value: 0,
                                checked: 0 === this.pickedTimeNum,
                            });
                        }
                        while (tempTime.getTime() <= this.maxPickUpTime.getTime()) {
                            timelabel = timeStringLabel(tempTime.getTime());
                            input.push({
                                type: 'radio',
                                label: timelabel,
                                value: (tempTime.getTime().toString()),
                                checked: tempTime.getTime() === this.pickedTimeNum,
                            });
                            m = 15;
                            m = this.systemConfigService.pickUpTimeInterval;
                            if (m > 0) {
                                // to do
                            }
                            else {
                                m = 15;
                            }
                            tempTime = new Date(tempTime.getTime() + m * 60000);
                        }
                        buttons.push(this.t.instant('buttons.cancel'));
                        buttons.push({
                            text: this.t.instant('buttons.ok'),
                            handler: function (data) {
                                console.log(data);
                                _this.pickedTimeNum = data;
                                var date = new Date(Number(data));
                                _this.timelabel = timeStringLabel(Number(data));
                                _this.pickedTime = getDateStringLabel(Number(data)) + 'T' + _this.timelabel + ':00.000';
                                console.log(_this.pickedTime);
                                if (0 === _this.pickedTimeNum || !data) {
                                    _this.timelabel = _this.getDefaultTimeLabel();
                                    if (!_this.orderService.isCourt) {
                                        _this.orderService.pickUpTime = null;
                                    } // 如果是court pickupTime采取页面开始时选择的Time
                                    _this.orderService.pickUpLabel = null;
                                }
                                else {
                                    _this.orderService.pickUpTime = _this.pickedTime;
                                    _this.orderService.pickUpLabel = _this.timelabel;
                                }
                            }
                        });
                        params['inputs'] = input;
                        params['buttons'] = buttons;
                        return [4 /*yield*/, this.alertController.create(params)];
                    case 1:
                        alert = _a.sent();
                        return [4 /*yield*/, alert.present()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    BaseCartPage.prototype.getMainItem = function (oi) {
        var mainGroup = oi.groups[0];
        var items = mainGroup.items;
        return items[0];
    };
    BaseCartPage.prototype.genOrder = function (sourceOrder) {
        return sourceOrder;
    };
    BaseCartPage.prototype.isGroupCompleted = function (group, index, quantity) {
        // console.log(group);
        if (!group) {
            return true;
        }
        if (group.min <= quantity || quantity === group.max) {
            return true;
        }
        if (group.optional) {
            if (group.skippable) {
                return true;
            }
            else {
                return index === -1;
            }
        }
        return false;
    };
    BaseCartPage.prototype.add = function (item, group, oi, isPreselect) {
        var _this = this;
        if (isPreselect === void 0) { isPreselect = false; }
        var groupIndex = item.groups.findIndex(function (g) {
            // TODO: is compared by id safe?
            return (g !== null && g !== undefined && g.id === group.id);
        }) + 1;
        var isOptional = group.min === 0;
        if (this.getGroupMode(group) === 'single') {
            // special request only can change isSelected
            var max = group.max;
            var able = true;
            if (!isPreselect) {
                if (this.isGroupCompleted(group, groupIndex, 1)) {
                    this.handlingModifier(oi, item, this.modifiableItemMap, function () {
                    }, function () {
                        // this.minusClicked(item, group);
                        _this.removeClicked(item);
                    }, false);
                }
                else if (isOptional) {
                    var realItem = item;
                    if (realItem.mgroups && realItem.mgroups.length > 0) {
                        this.handlingModifier(oi, item, this.modifiableItemMap, function () {
                        }, function () {
                            // this.minusClicked(item, group);
                            _this.removeClicked(item);
                        }, true);
                    }
                }
            }
        }
        else if (this.getGroupMode(group) === 'quantity') {
            // special request can change the number
        }
    };
    BaseCartPage.prototype.getImage = function (data) {
        var img = data.getImage('default', 200, true);
        return img;
    };
    BaseCartPage.prototype.checkStoreMaxItem = function () {
        var maxItems = this.orderManager.store.menu.maxItems;
        var infinity = maxItems === 0;
        return (maxItems <= this.orderManager.count && !infinity);
    };
    BaseCartPage.prototype.getCouponDisplayCondAndBenfit = function () {
        var benefit = null;
        var conds = [];
        if (this.orderService.couponMap['couponDisplay']) {
            var coupon = this.orderService.couponMap['couponDisplay'];
            if (coupon.conditions) {
                for (var _i = 0, _a = coupon.conditions; _i < _a.length; _i++) {
                    var cond = _a[_i];
                    if (cond.type === 'total') {
                        var total = this.t.instant('pages.cart.total');
                        conds.push(total + ' > ' + this.orderService.sign + cond.amount);
                    }
                }
            }
            if (coupon.benefits) {
                for (var _b = 0, _c = coupon.benefits; _b < _c.length; _b++) {
                    var b = _c[_b];
                    if (b.type === 'amount') {
                        benefit = this.orderService.sign + b.amount;
                    }
                }
            }
            this.orderService.couponMap['couponBenefit'] = benefit;
            this.orderService.couponMap['couponConds'] = conds;
        }
    };
    BaseCartPage.prototype.getPickupMaxTime = function (oi) {
        var earliestCategoryClosedTime = this.getEarliestCategoryClosedTime(oi);
        this.orderService.maxPickupTime = earliestCategoryClosedTime ? earliestCategoryClosedTime : this.getPeriodClosedTime(this.orderManager.store);
    };
    BaseCartPage.prototype.settingPickupTimeDisplay = function () {
        var oi = this.orderManager.getOrder().orderitems;
        this.getPickupMaxTime(oi);
        if (this.orderService.pickUpLabel && getTodayMillisecondsFromTimeString(this.orderService.maxPickupTime) < getTodayMillisecondsFromTimeString(this.orderService.pickUpLabel)) {
            this.orderService.pickUpLabel = null;
            if (!this.orderService.isCourt) {
                this.orderService.pickUpTime = null;
            } // 如果是court pickupTime采取页面开始时选择的Time
        }
        this.timelabel = this.orderService.pickUpLabel ? this.orderService.pickUpLabel : this.getDefaultTimeLabel();
        this.pickedTimeNum = getTodayMillisecondsFromTimeString(this.timelabel);
    };
    BaseCartPage.prototype.getModifierItemDisplay = function (imap, item) {
        if (item.quantity > 0) {
            var name_1 = item.name;
            // if (item.quantity > 1 ) {
            //     name = name + " x " + item.quantity;
            // }
            return name_1;
        }
        else if (imap && item.quantity === 0) {
            var result = null;
            var i = imap[item.id];
            if (i && i.absentId) {
                var absent = imap[i.absentId];
                if (absent) {
                    var name_2 = absent.name;
                    result = name_2;
                }
                else {
                    console.log('absent item not found', i.absentId);
                }
            }
            return result;
        }
        return null;
    };
    BaseCartPage.prototype.isValidOrder = function () {
        var payMethods = this.getPaymentMethods(this.payments);
        var size = Object.keys(payMethods).length;
        if (this.orderManager.isEmpty()) {
            this.showAlert('', this.t.instant('global.order-first'));
            return false;
        }
        // &&  this.orderManager.mode !== 'court'
        if (this.orderManager.mode === 'byod' && !this.orderService.spot && size <= 0 && !this.orderService.isCourt) { // 排除
            this.showAlert('', this.t.instant('global.table-warning-msg'));
            return false;
        }
        console.log('valid order');
        return true;
    };
    BaseCartPage.prototype.presentRewards = function () {
        return __awaiter(this, void 0, void 0, function () {
            var input, modal, offerDiscountId, _loop_1, this_1, _i, _a, o;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.orderManager.order.offers = [];
                        if (this.orderService.selectedReward) {
                            this.orderService.selectedReward.orderitems = [];
                        }
                        this.orderService.selectedReward = null;
                        this.orderManager.calculate();
                        input = { offers: this.offers };
                        return [4 /*yield*/, this.modalController.create({
                                component: OfferListDialog,
                                componentProps: input,
                                showBackdrop: true,
                                backdropDismiss: true,
                                cssClass: 'modal-largescreen',
                                animated: true
                            })];
                    case 1:
                        modal = _b.sent();
                        // reset offer related discount
                        console.log('this.offers', this.offers);
                        offerDiscountId = [];
                        _loop_1 = function (o) {
                            if (o.reward && o.reward.discount) {
                                this_1.orderManager.order.promotions.filter(function (p) { return (p.id !== o.reward.discount.id); });
                            }
                        };
                        this_1 = this;
                        for (_i = 0, _a = this.offers; _i < _a.length; _i++) {
                            o = _a[_i];
                            _loop_1(o);
                        }
                        modal.onWillDismiss().then(function (offer) {
                            // TODO: is this
                            if (offer.data) {
                                _this.clickReward(offer.data, _this.orderManager.store, 'ItemGridPage');
                                _this.applyPromotion();
                            }
                            else {
                                _this.orderService.selectedReward = null;
                                _this.orderManager.order.offers = [];
                                _this.applyPromotion();
                                _this.orderManager.calculate();
                                // this.cd.detectChanges();
                            }
                        });
                        modal.present();
                        return [2 /*return*/];
                }
            });
        });
    };
    BaseCartPage.prototype.continueOrder = function () {
        this.googleAnalyticEventTrack('back');
        this.navigationService.popPage();
    };
    BaseCartPage.prototype.isAvailableRewardUsed = function () {
        var _this = this;
        if (this.orderService.selectedReward) {
            return true;
        }
        else {
            var hasAvailableReward = false;
            for (var _i = 0, _a = this.offers; _i < _a.length; _i++) {
                var offer = _a[_i];
                if (isAvailableOffer(offer)) {
                    hasAvailableReward = true;
                    this.showAlert('', this.t.instant('pages.cart.use-reward'), [{
                            text: this.t.instant('buttons.yes'),
                            handler: function (data) {
                                _this.presentRewards();
                            }
                        }, {
                            text: this.t.instant('buttons.no'),
                            handler: function (data) {
                                if (_this.settings && _this.settings.tcPrompt && _this.settings.tcPrompt === 'payment') {
                                    _this.openTermsModal(_this.orderManager.store.brand, function (handle) {
                                        if (handle['fail'] === 'failed') {
                                            return;
                                        }
                                        _this.paymentHandling();
                                    }, TermsConditionsPage);
                                }
                                else {
                                    _this.checkPasscode();
                                    // this.paymentHandling();
                                }
                            }
                        }]);
                    break;
                }
            }
            return !hasAvailableReward;
        }
    };
    BaseCartPage.prototype.orderClicked = function () {
        var _this = this;
        console.log('orderClicked');
        if (!this.checkingDeliveryInformation(false) && this.orderManager.mode === 'delivery') {
            this.invalidAddress = true;
            this.showAlert('', 'Please enter address');
            return;
        }
        // check coupon
        if (this.orderService.couponMap['useCoupon'] && !this.orderService.couponMap['canUseCoupon']) {
            this.showAlert('', 'Please check the condition of the coupon');
            return;
        }
        //// Coupon GA performance tracking
        if (this.orderService.couponMap['canUseCoupon']) {
            if (this.orderService.couponMap['useCoupon']) {
                gtag('event', 'Coupon feature', {
                    'event_category': this.orderManager.store.name + '(Cart Page)',
                    'event_label': 'Success',
                    'value': 1
                });
            }
            else {
                gtag('event', 'Coupon feature', {
                    'event_category': this.orderManager.store.name + '(Cart Page)',
                    'event_label': 'Not in use',
                    'value': 1
                });
            }
        }
        else {
            gtag('event', 'Coupon feature', {
                'event_category': this.orderManager.store.name + '(Cart Page)',
                'event_label': 'Not match',
                'value': 1
            });
        }
        if (!this.orderService.preOrder && !this.isValidOrder()) {
            return;
        }
        if (this.orderManager.order.grandTotal - this.orderManager.order.handling < this.orderManager.store.menu.minDeliveryTotal && this.orderManager.mode === 'delivery') {
            var message = this.t.instant('global.min-delivery-message') + this.orderManager.store.currencySign + this.orderManager.store.menu.minDeliveryTotal;
            if (this.orderService.isBK) {
                message = this.t.instant('global.min-delivery-message-bk');
            }
            this.showAlert('', message);
            return;
        }
        if (this.orderManager.order.grandTotal - this.orderManager.order.handling > this.orderManager.store.menu.maxDeliveryTotal && this.orderManager.store.menu.maxDeliveryTotal > 0 && this.orderManager.mode === 'delivery') {
            var message = this.t.instant('global.max-delivery-message') + this.orderManager.store.currencySign + this.orderManager.store.menu.maxDeliveryTotal;
            if (this.orderService.isBK) {
                message = this.t.instant('global.max-delivery-message-bk');
            }
            this.showAlert('', message);
            return;
        }
        if (isPeriodClosed(this.orderManager.store, this.orderService.currentPeriod, new Date().getTime())) {
            var message = this.t.instant('global.no-service-message');
            this.showAlert('', message, [{
                    text: this.t.instant('buttons.ok'),
                    handler: function () {
                        if (_this.orderService.hiddenNav) {
                            _this.orderManager.clear();
                        }
                        _this.popToRoot();
                    }
                }]);
            return;
        }
        // check popup time
        if (this.orderService.pickUpLabel != null) {
        }
        else {
            if (this.systemConfigService.pickUpTimeRequired && this.settings.pickupTime) {
                this.showAlert('', this.t.instant('global.pick-up-time-invalid'));
                return;
            }
        }
        if (!this.isValidPickupTime()) {
            return;
        }
        if (!this.isAvailableRewardUsed()) {
            return;
        }
        var tncUrl = getTandCUrl(this.orderManager.store.brand, 'byodTc');
        this.orderService.clearPromoCodeGift();
        if (this.orderService.preOrder) {
            // var order = this.orderManager.getOrder();
            // order["locale"] = this.t.currentLang;
            var paymentInfo = { lang: this.t.currentLang, hideHistory: this.getNavParams('hideHistory') };
            this.configService.putPreference('paymentInfo', paymentInfo);
            this.configService.putPreference(this.orderManager.store.id + '.savedOrder', this.orderManager.getOrder());
            this.pushByUrl(RouteTable['SavedOrderListPage']);
        }
        else if (this.settings && this.settings.tcPrompt && this.settings.tcPrompt === 'payment' && tncUrl) {
            this.openTermsModal(this.orderManager.store.brand, function (handle) {
                console.log('terms handle', handle);
                if (handle['fail'] === 'failed') {
                    return;
                }
                if (_this.systemConfigService.showLoginInCartPage && !_this.memberService.member) {
                    _this.loginReminderAlert();
                }
                else {
                    _this.paymentHandling();
                }
            }, TermsConditionsPage);
        }
        else {
            this.checkPasscode();
            // this.paymentHandling();
        }
    };
    BaseCartPage.prototype.ngOnDestroy = function () {
        this.monitoringService.unlistenAll();
        if (this.onOrderChangeSubscriber) {
            this.onOrderChangeSubscriber.unsubscribe();
        }
    };
    BaseCartPage.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        // flag control for show order q
        if (this.systemConfigService.showOrderQueueInCart) {
            this.checkFirebaseStoreOrders();
        }
        if (this.orderService.isBK) {
            this.getRewards();
            this.getBKMember();
        }
        else if (this.orderService.login && this.memberService.getMember()) {
            /*******
             * 暫時不用處理
             因為涉及member的話，現階段應該會有一連串要處理
             先做其他比較重要的flow
             preorder之下，可以無視payment有關的東西，包括total, discount, payment method 等 ********/
            if (this.orderService.preOrder) {
                return;
            } // 所以return
            this.checkingMembership(this.orderManager.store, function (hasMemberShip) {
                if (!hasMemberShip) {
                    return;
                }
                var memberShip = _this.memberService.member.membership || {};
                _this.userTotalPoints = memberShip.usablePoints || 0;
                var grandTotal = _this.order.grandTotal;
                _this.orderManager.order.usedPoints = 0;
                _this.orderManager.crmPointRatio = _this.getCrmPointRatio();
                _this.setPointSelection();
                _this.onOrderChangeSubscriber = _this.orderManager.onOrderitemsChange.subscribe(function (data) {
                    _this.setPointSelection();
                });
                if (_this.memberService.offers && _this.memberService.offers.length > 0) {
                    _this.offers = _this.memberService.offers;
                    _this.loading(false);
                }
                else {
                    _this.loading(true);
                    _this.orderService.getReward().subscribe(function (offers) {
                        _this.loading(false);
                        _this.offers = offers;
                    }, function (err) {
                        _this.loading(false);
                        if (err.status === 401) {
                            var alert_1 = _this.showAlert(err.status, err['_body'], [{
                                    text: _this.t.instant('buttons.ok'),
                                    handler: function () {
                                        _this.memberService.clear();
                                        _this.popToRoot();
                                        _this.loading(false);
                                    }
                                }]);
                            alert_1.then(function (data) { return data.present(); });
                        }
                        else {
                            _this.showError(err);
                        }
                    }, function () {
                        _this.loading(false);
                    });
                }
            });
        }
    };
    BaseCartPage.prototype.giftHandling = function (showPromoToast) {
        var order = this.orderManager.getOrder();
        var promotions = order && order.promotions || [];
        var appliedCodeSuccess = false;
        // clear all previously stored gift
        this.orderService.generalGift.length = 0;
        this.orderService.promoCodeGift.length = 0;
        var _loop_2 = function (prom) {
            var benefits = prom && prom.benefits || [];
            var conditions = prom && prom.conditions || [];
            if (!conditions || conditions.length === 0 || !benefits || benefits.length === 0 || !prom.enabled) {
                return "continue";
            }
            var isCode = false;
            var isSeats = false;
            var isSource = false;
            for (var _i = 0, conditions_1 = conditions; _i < conditions_1.length; _i++) {
                var cond = conditions_1[_i];
                if (cond.type === 'code') {
                    isCode = true;
                }
            }
            console.log('checking promo', prom);
            var typeIsGift = (benefits[0].type === 'gift') || false;
            var applicable = true;
            var cFail = false;
            for (var _a = 0, _b = prom.conditions; _a < _b.length; _a++) {
                var c = _b[_a];
                if (c.applicable === 0) {
                    cFail = true;
                    break;
                }
            }
            if (cFail) {
                applicable = false;
            }
            var benefitCode = benefits[0].code;
            if (typeIsGift) {
                if (applicable && benefits[0].applied && benefitCode) {
                    // showPromoToast && this.showToast(this.t.instant('pages.cart.discount-code-ok'));
                    var giftCats = this_2.menuManager.getAvailableGifts(this_2.orderService.store, this_2.now, this_2.orderManager.mode === 'takeaway') || [];
                    for (var _c = 0, giftCats_1 = giftCats; _c < giftCats_1.length; _c++) {
                        var giftCat = giftCats_1[_c];
                        var items = this_2.menuManager.getAvailableMainItems(this_2.orderService.store, giftCat, this_2.orderManager.mode === 'takeaway') || [];
                        var freeGift = items.find(function (i) { return i.id === benefitCode; });
                        if (freeGift) {
                            var cond = this_2.discountManager.getMainCondition(conditions);
                            var count = cond.applicable;
                            if (benefits[0].max && benefits[0].max < cond.applicable) {
                                count = prom.benefits[0].max;
                            }
                            if (isCode) {
                                while (count--) {
                                    this_2.orderService.promoCodeGift.push(freeGift);
                                    break;
                                }
                                appliedCodeSuccess = true;
                                this_2.isPromoCodeFalse = false;
                                showPromoToast && this_2.showToast(this_2.t.instant('pages.cart.discount-code-ok'));
                            }
                            else {
                                // other gift benefit promo condition
                                // while (count--) {
                                //     this.orderService.generalGift.push(freeGift);
                                // }
                                freeGift['quantity'] = count;
                                this_2.orderService.generalGift.push(freeGift);
                                break;
                            }
                            break;
                        }
                    }
                    // this.calDiscounts();
                }
                else {
                    if (!appliedCodeSuccess && isCode && this_2.discountCode) {
                        this_2.orderService.promoCodeGift.length = 0;
                        this_2.isPromoCodeFalse = true;
                    }
                }
            }
        };
        var this_2 = this;
        for (var _i = 0, promotions_1 = promotions; _i < promotions_1.length; _i++) {
            var prom = promotions_1[_i];
            _loop_2(prom);
        }
        console.log('###this.orderService.generalGift', this.orderService.generalGift);
    };
    BaseCartPage.prototype.showCouponCode = function () {
        return __awaiter(this, void 0, void 0, function () {
            var alert;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.alertController.create({
                            header: this.t.instant('pages.cart.input-coupon-code'),
                            inputs: [{
                                    name: 'couponCode',
                                    type: 'text',
                                    label: this.t.instant('pages.cart.input-coupon-code'),
                                    value: ''
                                }],
                            buttons: [
                                {
                                    text: this.t.instant('buttons.cancel'),
                                    handler: function () {
                                    }
                                },
                                {
                                    text: this.t.instant('buttons.ok'),
                                    handler: function (_a) {
                                        var couponCode = _a.couponCode;
                                        _this.couponCode = couponCode;
                                        if (_this.applyCouponCode(couponCode)) {
                                            _this.showToast(_this.t.instant('pages.cart.coupon-code-fail'), 2000, 'top', 'error-alert');
                                            return false;
                                        }
                                    }
                                }
                            ]
                        })];
                    case 1:
                        alert = _a.sent();
                        return [4 /*yield*/, alert.present()];
                    case 2:
                        _a.sent();
                        gtag('event', 'Coupon feature', {
                            'event_category': this.orderManager.store.name + '(Cart Page)',
                            'event_label': 'Code input initialization',
                            'value': 1
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    BaseCartPage.prototype.checkCouponCondition = function () {
        var canUse = false;
        var order = this.orderManager.getOrder();
        if (order && order.discounts && order.discounts.length > 0) {
            for (var _i = 0, _a = order.discounts; _i < _a.length; _i++) {
                var d = _a[_i];
                if (d.conditions) {
                    for (var _b = 0, _c = d.conditions; _b < _c.length; _b++) {
                        var cond = _c[_b];
                        if (cond.type === 'coupon') {
                            this.orderService.couponMap['canUseCoupon'] = true;
                            canUse = true;
                            break;
                        }
                    }
                }
            }
        }
        else {
            this.orderService.couponMap['canUseCoupon'] = false;
        }
        if (!canUse) {
            this.orderService.couponMap['canUseCoupon'] = false;
        }
    };
    //
    BaseCartPage.prototype.applyDiscountCode = function (discountCode) {
        console.log('applyDiscountCode');
        this.isPromoCodeFalse = false;
        if (discountCode && !this.orderManager.isEmpty()) {
            // var amountBefore = this.orderManager.getOrder().grandTotal;
            // this.orderManager.setDiscountCode("");
            this.orderManager.setDiscountCode(discountCode);
            // this.discountManager.applyPromotions(this.orderManager.getOrder(), this.orderManager.order.promotions);
            this.applyPromotion();
            this.orderManager.calculate();
            // var amountAfter = this.orderManager.getOrder().grandTotal;
            var order = this.orderManager.getOrder();
            console.log('applyDiscountCode after order:', order);
            if (order.discounts && order.discounts.length > 0) {
                for (var _i = 0, _a = order.discounts; _i < _a.length; _i++) {
                    var discount = _a[_i];
                    if (discount.conditions && discount.conditions.length > 0) {
                        for (var _b = 0, _c = discount.conditions; _b < _c.length; _b++) {
                            var condition = _c[_b];
                            if (condition.type && condition.type === 'code') {
                                this.isPromoCodeFalse = false;
                            }
                        }
                    }
                }
            }
        }
        return this.isPromoCodeFalse; // when ture, code not correct
    };
    BaseCartPage.prototype.getAvailableOffers = function (offers) {
        var tmp = offers.filter(function (offer) {
            var current = new Date().getTime();
            var start = offer.start ? offer.start : current;
            var end = offer.expire ? offer.expire : current;
            return start <= current && end >= current;
        });
        return tmp;
    };
    BaseCartPage.prototype.checkModifiableItems = function () {
        var orderManager = this.orderManager;
        var itemMap = {};
        if (orderManager.isEmpty()) {
            return;
        }
        var gmap = orderManager.store.menu['gmap'];
        for (var _i = 0, _a = orderManager.order.orderitems; _i < _a.length; _i++) {
            var oi = _a[_i];
            if (OrderItem.isSet(oi)) {
                for (var _b = 0, _c = oi.items; _b < _c.length; _b++) {
                    var item = _c[_b];
                    if (item.modifiable) {
                        itemMap[oi.items[0].id] = oi.items[0];
                    }
                }
            }
            else {
                var mainGroup = oi.groups[0];
                var realIg = gmap[mainGroup.id];
                for (var _d = 0, _e = realIg.items; _d < _e.length; _d++) {
                    var item = _e[_d];
                    var mgroups = item.mgroups;
                    var modifiable = mgroups && mgroups.some(function (mgroup) {
                        var mitems = mgroup.items;
                        return mitems && mitems.length > 0;
                    });
                    if (modifiable) {
                        itemMap[item.id] = item;
                    }
                }
            }
        }
        this.modifiableItemMap = itemMap;
    };
    BaseCartPage.prototype.applyCouponCode = function (couponCode) {
        var _this = this;
        console.log('apply coupon code');
        this.couponCode = couponCode;
        if (this.couponCode) {
            this.loading(true);
            this.orderService.postCouponCode(this.couponCode, this.orderService.store.brandId, this.orderService.store.id).subscribe(function (res) {
                _this.loading(false);
                console.log(res);
                _this.orderService.couponMap['canShowCouponInput'] = false;
                _this.orderService.couponMap['couponDisplay'] = res;
                _this.orderService.couponMap['useCoupon'] = true;
                _this.getCouponDisplayCondAndBenfit();
                // push discount
                if (_this.orderService.store.menu && _this.orderService.store.menu.discounts) {
                    var cCode = void 0;
                    var secret = void 0;
                    if (res && res.conditions && res.conditions.length > 0) {
                        for (var _i = 0, _a = res.conditions; _i < _a.length; _i++) {
                            var c = _a[_i];
                            if (c.type === 'coupon') {
                                cCode = c.couponCode;
                                secret = c.secret;
                            }
                        }
                    }
                    var coupon = {
                        'inputCode': _this.couponCode,
                        'couponCode': cCode,
                        'discountId': res.id,
                        'secret': secret
                    };
                    _this.orderService.couponMap['coupon'] = coupon;
                    _this.orderService.couponMap['couponMenuDiscounts'] = {};
                    // this.orderService.couponMenu = Object.assign({}, this.store.menu);
                    _this.orderService.couponMap['couponMenuDiscounts'] = JSON.parse(JSON.stringify(_this.orderService.store.menu.discounts));
                    _this.orderService.couponMap['couponMenuDiscounts'].push(res);
                    console.log('couponMenu', _this.orderService.couponMap['couponMenuDiscounts']);
                    console.log('this.store.menu', _this.orderService.store.menu);
                    _this.orderManager.setNewDiscounts(_this.orderService.couponMap['couponMenuDiscounts']);
                    _this.applyPromotion();
                    gtag('event', 'Coupon feature', {
                        'event_category': _this.orderManager.store.name + '(Cart Page)',
                        'event_label': 'Coupon applied',
                        'value': 1
                    });
                    _this.orderManager.calculate();
                }
                console.log(_this.orderManager.getOrder());
                return true;
            }, function (err) {
                _this.loading(false);
                console.log(err);
                _this.showError(err);
                return false;
            });
        }
        return false;
    };
    BaseCartPage.prototype.calDiscounts = function () {
        if (this.orderManager.order && !this.orderManager.order.member && this.memberService.getMember()) {
            this.orderManager.order.member = this.memberService.getMember();
            this.memberService.putMember(this.orderManager.order.member);
        }
        if (this.orderManager.order && this.orderManager.order.promotions && this.orderManager.order.promotions.length > 0) {
            this.discountManager.applyPromotions(this.orderManager.order, this.orderManager.order.promotions);
        }
    };
    BaseCartPage.prototype.ionViewDidEnter = function () {
        // this.checkModifiableItems();
        // console.log('ionViewDidEnter() : orderItems', this.orderManager.order.orderitems);
    };
    BaseCartPage.prototype.ionViewWillLeave = function () {
        _super.prototype.ionViewWillLeave.call(this);
        this.monitoringService.unlistenAll();
    };
    BaseCartPage.prototype.ionViewWillEnter = function () {
        this.applyPromotion();
        _super.prototype.ionViewWillEnter.call(this);
        this.invalidAddress = !this.checkingDeliveryInformation(false);
    };
    BaseCartPage.prototype.getGroupMode = function (group) {
        return group.repeat ? 'quantity' : 'single';
    };
    /** 最大的可使用积分:
     * 1. 可使用积分扣除多少钱,
     * 2. order.grandTotal/,
     *
     * the point user can earned is: (grandTotal - pointPaidAmount)/crm.pointRatio
     * need a flag to control whether tax/service change included or not
     */
    BaseCartPage.prototype.setPointSelection = function () {
        var points = [];
        points.push(0);
        // if (!this.pointPayment) {
        //     this.points = [];
        //     console.warn('no point payment, should not run this function');
        //     return;
        // }
        if (!this.store) {
            this.points = [];
            console.warn('no point payment, should not run this function');
            return;
        }
        if (this.store && this.store.crm && this.pointFeature) {
            var _a = this.store.crm, redeemPointFactor = _a.redeemPointFactor, pointToMoneyRatio = _a.pointToMoneyRatio, pointRatio = _a.pointRatio, redeemPointMin = _a.redeemPointMin;
            if (!redeemPointFactor && !pointToMoneyRatio && !pointRatio) { // crm 无set这三个值没有point功能
                this.points = [];
                console.warn('no crm point params, should not run this function');
                return;
            }
            if (this.userTotalPoints === 0) {
                console.warn('this membere dont have points');
                this.points = [];
                return;
            }
            this.orderManager.pointsFactor = 1 / pointToMoneyRatio; // 不修改ng-core的前提下, 用pointToMoneyRatio替换pointsFactor
            this.orderManager.order.usablePoints = this.userTotalPoints;
            var charge = (this.store && this.store.menu && this.store.menu.serviceCharge) || 0;
            console.log('charge:', charge);
            var maxPointPaidAmount = Math.min(this.userTotalPoints / pointToMoneyRatio, // 可使用积分扣除多少钱
            this.orderManager.getOrder().grandTotal);
            var count = parseInt((maxPointPaidAmount * pointToMoneyRatio / redeemPointFactor).toString(), 0); // 可循环的次数
            // when service charge  != 0
            for (var i = 1; i <= count; i++) { // count = 3 ,  log : 1,2,3
                i * redeemPointFactor > redeemPointMin && points.push(i * redeemPointFactor);
            }
            this.points = points;
            // reset point selection if necessary
            if (this.selectedPoint > points[count]) {
                this.selectedPoint = 0;
            }
            console.log('update point selection', this.points);
            this.onPointSelectUpdate();
        }
        else {
            this.points = [];
            console.warn('no pointFeature, should not run this function');
            return;
        }
    };
    BaseCartPage.prototype.onPointSelectUpdate = function () {
        this.orderManager.order.usedPoints = this.selectedPoint;
        // TODO: add flag to control whether tax/service charge is count into point? now is not included
        var temp = Math.floor((this.orderManager.getNetAmount() - this.orderManager.getOrder().tax - this.orderManager.getOrder().serviceCharge) / this.getCrmPointRatio());
        this.pointEarned = temp >= 0 ? temp : 0;
    };
    BaseCartPage.prototype.checkPasscode = function () {
        // TODO add new API access to get OTP
        var pos = this.orderManager.store.pos;
        var otp = pos && ('passcode' === pos['tableLock']);
        // TODO if need cache passcode??
        if (otp) {
            this.passcode = '';
            this.otp = otp;
            this.showPassCode = true;
        }
        else {
            if (this.systemConfigService.showLoginInCartPage && !this.memberService.member) {
                this.loginReminderAlert();
            }
            else {
                this.paymentHandling();
            }
        }
    };
    BaseCartPage.prototype.editAddress = function () {
        this.pushByName('DeliveryInformationPage', { edit: true });
    };
    BaseCartPage.prototype.closeClicked = function () {
        console.log('close clicked');
        this.wrong = false;
        this.showPassCode = false;
        this.otp = false;
    };
    BaseCartPage.prototype.submit = function () {
        var _this = this;
        if (this.otp) {
            this.loading(true);
            this.orderService.checkOTP(this.passcode).subscribe(function (verify) {
                _this.loading(false);
                if (verify) {
                    _this.orderService.passcode = _this.passcode;
                    _this.closeClicked();
                    _this.paymentHandling();
                }
                else {
                    _this.wrong = true;
                    _this.passcode = '';
                    _this.myInput.setFocus();
                }
            }, function (error) {
                console.log(error);
                _this.showError(error);
            });
        }
    };
    BaseCartPage.prototype.getAddressString = function () {
        var addressString;
        for (var key in this.orderService.address) {
            if (key !== 'comment' && this.orderService.address[key]) {
                addressString = addressString === null ? this.orderService.address[key] : (addressString + ',' + this.orderService.address[key]);
            }
        }
        return addressString;
    };
    BaseCartPage.prototype.applyPromotion = function (showPromoToast) {
        if (showPromoToast === void 0) { showPromoToast = true; }
        // if pmtType === "aigens"
        this.calDiscounts();
        this.giftHandling(showPromoToast);
        this.unlockHandling();
        this.checkCouponCondition();
        console.log('apply promotion');
        console.log('申请折扣后', this.orderManager.order);
        console.log('orderService.promoCodeGift', this.orderService.promoCodeGift, this.orderService.promoCodeGift.length);
    };
    BaseCartPage.prototype.unlockHandling = function (afterUnlockApply, skip) {
        var _this = this;
        if (afterUnlockApply === void 0) { afterUnlockApply = false; }
        if (skip === void 0) { skip = false; }
        var unlocks = this.menuManager.getAvailableUnlocks(this.store, this.now, this.order.takeout);
        var firstUnlock = true;
        for (var _i = 0, _a = this.order.promotions; _i < _a.length; _i++) {
            var promotion = _a[_i];
            for (var _b = 0, _c = promotion.benefits; _b < _c.length; _b++) {
                var benefit = _c[_b];
                if (benefit.type === 'unlock' && unlocks && unlocks.length > 0) {
                    var cFail = false;
                    for (var _d = 0, _e = promotion.conditions; _d < _e.length; _d++) {
                        var c = _e[_d];
                        if (c.applicable === 0) {
                            cFail = true;
                            break;
                        }
                    }
                    if (cFail) {
                        if (this.order.gifts) {
                            for (var _f = 0, _g = this.order.gifts; _f < _g.length; _f++) {
                                var gift = _g[_f];
                                for (var _h = 0, _j = promotion.benefits; _h < _j.length; _h++) {
                                    var pu = _j[_h];
                                    if (pu.code === gift.categoryId) {
                                        while (gift.quantity > 0) {
                                            this.orderManager.minusOrderItem(gift);
                                        } // a la carte
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        if (skip) {
            return;
        }
        if (!this.showedBox && this.order.promotions) {
            var _loop_3 = function (promotion) {
                var _loop_4 = function (benefit) {
                    if (benefit.type === 'unlock' && benefit.applied && unlocks && unlocks.length > 0) {
                        var cFail = false;
                        for (var _i = 0, _a = promotion.conditions; _i < _a.length; _i++) {
                            var c = _a[_i];
                            if (c.applicable === 0) {
                                cFail = true;
                                break;
                            }
                        }
                        if (cFail) {
                            return "continue";
                        }
                        if (firstUnlock) {
                            firstUnlock = false;
                        }
                        else {
                            return { value: void 0 };
                        }
                        if (this_3.order.gifts) {
                            for (var _b = 0, _c = this_3.order.gifts; _b < _c.length; _b++) {
                                var gift = _c[_b];
                                if (this_3.order.orderitems.indexOf(gift) >= 0) {
                                    return { value: void 0 };
                                }
                            }
                        }
                        console.log('show unlock discount?');
                        var code_1 = benefit.code;
                        console.log('benefit code', code_1);
                        unlocks.forEach(function (unlock) {
                            if (code_1 === unlock.id) {
                                _this.showedBox = true;
                                if (_this.orderManager.isEmpty()) {
                                    _this.navController.pop();
                                }
                                else {
                                    var c = promotion.conditions[0].applicable;
                                    _this.showUnlock(unlock, Math.max(benefit.max, c ? c : 1));
                                }
                                // for (let condition of promotion.conditions) {
                                //     this.showUnlock(unlock, Math.max(benefit.max, condition.applicable));
                                // }
                            }
                        });
                    }
                };
                for (var _i = 0, _a = promotion.benefits; _i < _a.length; _i++) {
                    var benefit = _a[_i];
                    var state_2 = _loop_4(benefit);
                    if (typeof state_2 === "object")
                        return state_2;
                }
            };
            var this_3 = this;
            for (var _k = 0, _l = this.order.promotions; _k < _l.length; _k++) {
                var promotion = _l[_k];
                var state_1 = _loop_3(promotion);
                if (typeof state_1 === "object")
                    return state_1.value;
            }
        }
    };
    BaseCartPage.prototype.getRewards = function () {
        var _this = this;
        if (this.orderManager.mode !== 'delivery') {
            this.orderService.getBKReward().subscribe(function (offers) {
                _this.offers = offers;
            });
        }
    };
    BaseCartPage.prototype.showUnlock = function (unlock, max) {
        var _this = this;
        if (max === void 0) { max = 0; }
        if (unlock && max > 0) {
            this.order.gifts = [];
            console.log('Unlocked: ', unlock);
            var now = this.configService.getTime();
            var mainIg = unlock.groups[0];
            var unlockItems = [];
            unlockItems = this.menuManager.getAvailableMainItems(this.store, unlock, this.order.takeout);
            unlockItems.forEach(function (i) {
                i.quantity = 0;
            });
            if (unlockItems.length > 0) {
                console.log('Dialog show: recommend-list');
                var input = {
                    recommendList: unlock,
                    items: unlockItems,
                    store: this.store,
                    max: max,
                    isGift: true
                };
                this.presentDialog2(UnlockPopupDialog, input, function (data) {
                    console.log('present dialog 2 data', data);
                    if (data && data.data === 'ok') {
                        _this.applyPromotion();
                    }
                    _this.showedBox = false;
                });
            }
        }
        else {
            this.showedBox = false;
        }
    };
    BaseCartPage.prototype.presentDialog2 = function (page, params, callback, animate) {
        if (params === void 0) { params = null; }
        if (callback === void 0) { callback = null; }
        if (animate === void 0) { animate = false; }
        return __awaiter(this, void 0, void 0, function () {
            var modal;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.modalController.create({
                            component: page,
                            componentProps: params,
                            showBackdrop: true,
                            backdropDismiss: true,
                            cssClass: 'modal-unlockpop',
                            animated: true
                        })];
                    case 1:
                        modal = _a.sent();
                        modal.onDidDismiss().then(function (data) {
                            if (callback) {
                                callback(data);
                            }
                            console.log('onDidDismiss');
                            modal = null;
                        });
                        console.log('modal.present();');
                        try {
                            modal.present().then(function (data) {
                                console.log(data);
                            }).catch(function (e) {
                                console.log(e);
                            });
                        }
                        catch (e) {
                            console.error(e);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    BaseCartPage.prototype.couponClicked = function () {
        console.log('coupon clicked');
        this.orderService.couponMap['useCoupon'] = !this.orderService.couponMap['useCoupon'];
        if (!this.orderService.couponMap['useCoupon']) {
            // for not use
            this.orderManager.setDiscounts(this.orderService.store.menu);
            this.applyPromotion(false);
            this.orderManager.calculate();
        }
        else {
            this.orderManager.setNewDiscounts(this.orderService.couponMap['couponMenuDiscounts']);
            this.applyPromotion(false);
            this.orderManager.calculate();
        }
    };
    BaseCartPage.prototype.netsPayHandling = function (paymentObject) {
        var _this = this;
        if (this.orderManager.mode !== 'delivery' && (!this.BKMember || !this.BKMember.email || !this.BKMember.phone)) {
            this.showAlert(null, 'Error getting email/phone, please try again.');
            return;
        }
        else if (!paymentObject) {
            this.showAlert(null, 'miss netspay charge');
            return;
        }
        else {
            if (this.orderManager.mode === 'delivery' && this.orderService.email && this.orderService.phone) {
                console.log('jadd this.orderService.phone email', this.orderService.phone, this.orderService.email);
                this.BKMember.email = this.orderService.email;
                this.BKMember.phone = this.orderService.phone;
            }
            var netspayManager = new NetspayManager();
            // payCallback['result'] ? "success" : "failure"
            // if success ,  let order = payCallback['order']
            netspayManager.pay(function (netspayManagerCallback, callNetspayAPP, errorCallback) {
                if (!_this.isValidPickupTime()) {
                    if (netspayManagerCallback) {
                        errorCallback(netspayManagerCallback);
                    }
                    return;
                }
                _this.orderService.email = _this.BKMember.email;
                _this.orderService.phone = _this.BKMember.phone;
                _this.loading(true);
                _this.monitoringService.listenStoreKioskStatus(_this.orderManager.store, function () {
                    _this.loading(false);
                    _this.showAlert('', _this.t.instant('global.kiosk-offline-message'), [{
                            text: _this.t.instant('buttons.ok'),
                            handler: function () {
                                if (_this.orderManager.mode === 'delivery') {
                                    _this.popToRoot();
                                }
                                else {
                                    if (genkiJSInterface.exitwebview) {
                                        genkiJSInterface.exitwebview();
                                    }
                                }
                            }
                        }]);
                    if (netspayManagerCallback) {
                        errorCallback(netspayManagerCallback);
                    }
                }, function () {
                    _this.modifierItemHandling(_this.orderManager.order);
                    if (_this.orderManager.mode === 'delivery') {
                        var today = new Date().getTime() + 10 * 60000;
                        var timelabel = timeStringLabel(today);
                        var pickedTime = getDateStringLabel(today) + 'T' + timelabel + ':00.000';
                        _this.orderService.pickUpTime = pickedTime;
                    }
                    _this.orderService.postBKOrder(_this.orderManager.order, paymentObject, true).subscribe(function (orders) {
                        _this.loading(false);
                        console.log('jadd orders:', orders);
                        callNetspayAPP(netspayManagerCallback, orders);
                    }, function (err) {
                        _this.loading(false);
                        if (err.status === 401) {
                            if (_this.browserService.isBKApp()) {
                                if (genkiJSInterface.setSessionExpire) {
                                    genkiJSInterface.setSessionExpire(true);
                                }
                                if (genkiJSInterface.hasAlert) {
                                    genkiJSInterface.hasAlert(true);
                                }
                            }
                            _this.showAlert(err.status, err['_body'], [{
                                    text: _this.t.instant('buttons.ok'),
                                    handler: function () {
                                        if (genkiJSInterface.exitwebview) {
                                            genkiJSInterface.exitwebview();
                                        }
                                    }
                                }]).then(function (alert) {
                                alert.onDidDismiss().then(function (data) {
                                    if (genkiJSInterface.hasAlert) {
                                        genkiJSInterface.hasAlert(false);
                                    }
                                });
                            });
                        }
                        else {
                            _this.showError(err);
                        }
                        if (netspayManagerCallback) {
                            errorCallback(netspayManagerCallback);
                        }
                    });
                });
            }, function (payCallback) {
                console.log('jadd netspayManager payCallback:', payCallback);
                var message = payCallback['result'] ? 'Successful payment' : 'Payment failed, Please re-order.';
                _this.showAlert(null, message).then(function (data) {
                    data.onDidDismiss().then(function (value) {
                        _this.setRoot(ByodSummaryPage, { orders: payCallback['order'] }).then(function () {
                            _this.orderService.clear();
                        });
                    });
                });
            });
        }
    };
    BaseCartPage.prototype.checkFirebaseStoreOrders = function () {
        var _this = this;
        var today = new Date();
        var todayTime = this.datePipe.transform(today, 'yyyy-MM-dd');
        var res = 'update/' + todayTime + '/order/' + this.orderService.store.id;
        var count = 0;
        this.monitoringService.listenStoreOrder(res, function (current) {
            // console.log("orders first view detected",current);
            var storeOrders = current;
            count = 0; // for reset
            for (var sOrderId in storeOrders) {
                if (today.getTime() > storeOrders[sOrderId].create && storeOrders[sOrderId].status === 'received') {
                    count++;
                }
            }
            _this.orderQueue = count;
            _this.monitoringService.unlistenAll();
            console.log('orderQueue', _this.orderQueue); // orderq
        }, null, null);
    };
    BaseCartPage.prototype.modifierItemHandling = function (order) {
        var imap = this.orderManager.store.menu['imap'];
        order.orderitems.forEach(function (orderitem) {
            orderitem.groups.forEach(function (group, gindex) {
                group.items.forEach(function (item, iindex) {
                    if (item.mgroups && item.mgroups.length > 0) {
                        item.mgroups.forEach(function (mgroup, mindex) {
                            mgroup.items.forEach(function (mitem, index) {
                                if (imap && mitem.quantity === 0) {
                                    var i = imap[mitem.id];
                                    if (i && i.absentId) {
                                        var absent = imap[i.absentId];
                                        if (absent) {
                                            mgroup.items[mindex] = absent;
                                        }
                                    }
                                }
                            });
                        });
                    }
                });
            });
        });
    };
    BaseCartPage.prototype.presentPaymentMethod = function (methods) {
        return __awaiter(this, void 0, void 0, function () {
            var buttons, hideHistory, order_, params, _loop_5, this_4, key, actionSheet;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        buttons = [];
                        hideHistory = this.settings ? this.settings.hideHistory : false;
                        if (this.orderManager.order.grandTotal <= 0) {
                            this.showAlert('Error', 'Invalid order grand total');
                            return [2 /*return*/];
                        }
                        console.log('methods', methods);
                        order_ = this.genOrder(this.orderManager.getOrder());
                        order_.grandTotal = this.orderManager.getNetAmount();
                        order_.usedPoints = Number(this.selectedPoint);
                        params = {
                            order: order_,
                            hideHistory: hideHistory,
                            store: this.orderManager.store
                        };
                        _loop_5 = function (key) {
                            if (key === 'creditcard') {
                                buttons.push({
                                    icon: 'payment-ccard',
                                    text: this_4.t.instant('payments.creditcard'),
                                    cssClass: key + ' pay-button',
                                    handler: function () {
                                        var gateway = methods[key]['gateway'];
                                        var page = null;
                                        switch (gateway) {
                                            case 'mpgs':
                                                page = 'MpgsHostSessionPage';
                                                break;
                                            case 'wirecard':
                                                page = 'WirecardCreditCard';
                                                break;
                                            case 'wirecardV2':
                                                page = 'WirecardCreditCardV2';
                                                break;
                                            case 'openrice':
                                                page = 'OpenricePaymentPage';
                                                break;
                                            case 'aino':
                                                page = 'RedirectPayment';
                                                break;
                                            case 'cashlez':
                                                page = 'RedirectPayment';
                                                break;
                                            case 'c2p':
                                                page = 'RedirectPayment';
                                                break;
                                            case 'midTrans':
                                                page = 'MidTransPayment';
                                                break;
                                            default:
                                                page = 'CreditCardPaymentPage';
                                        }
                                        params['payment'] = methods[key];
                                        _this.pushByName(page, params, { relativeTo: _this.route });
                                    }
                                });
                            }
                            else if (key === 'session') {
                                buttons.push({
                                    icon: 'payment-ccard',
                                    text: this_4.t.instant('payments.creditcard'),
                                    cssClass: key + ' pay-button',
                                    handler: function () {
                                        params['payment'] = methods[key];
                                        _this.pushByName('MpgsHostSessionPage', params, { relativeTo: _this.route });
                                    }
                                });
                            }
                            else if (key === 'apple') {
                                buttons.push({
                                    icon: 'payment-apple',
                                    text: this_4.t.instant('payments.applepay'),
                                    cssClass: key + ' pay-button',
                                    handler: function () {
                                        var page = null;
                                        switch (methods[key]['gateway']) {
                                            case 'mpgs':
                                                page = 'MpgsApplePayPaymentPage';
                                                break;
                                            case 'openrice':
                                                page = 'OpenricePaymentPage';
                                                break;
                                            default:
                                                page = 'StripeApplePaymentPage';
                                        }
                                        params['payment'] = methods[key];
                                        _this.pushByName(page, params, { relativeTo: _this.route });
                                    }
                                });
                            }
                            else if (key === 'android') {
                                buttons.push({
                                    icon: 'payment-gpay',
                                    text: this_4.t.instant('payments.androidpay'),
                                    cssClass: key + ' pay-button',
                                    handler: function () {
                                        var gateway = methods[key]['gateway'];
                                        var page = null;
                                        switch (gateway) {
                                            case 'mpgs':
                                                page = 'MpgsGooglePayPaymentPage';
                                                break;
                                            case 'openrice':
                                                page = 'OpenricePaymentPage';
                                                break;
                                            case 'wirecard':
                                                page = 'WirecardGooglePayPaymentPage';
                                                break;
                                            default:
                                                page = 'StripeGooglePayPaymentPage';
                                        }
                                        params['payment'] = methods[key];
                                        _this.pushByName(page, params, { relativeTo: _this.route });
                                    }
                                });
                            }
                            else if (key.startsWith('alipay.')) {
                                var gateway = methods[key]['gateway'];
                                var isEft = gateway.startsWith('eft');
                                if (isEft) {
                                    if ((this_4.orderService.isStaff && methods[key]['sub'] === 'scan') || (!this_4.orderService.isStaff && methods[key]['sub'] !== 'scan')) {
                                        if (this_4.browserService.isAlipayHK() && gateway !== 'eft-cn') {
                                            buttons.push({
                                                icon: 'payment-alipay',
                                                text: this_4.t.instant('payments.alipayHK'),
                                                cssClass: key + ' pay-button',
                                                handler: function () {
                                                    // var isEft = methods[key]["gateway"] === "eft";
                                                    var page = 'EftPaymentPage';
                                                    params['payment'] = methods[key];
                                                    params['wallet'] = 'HK';
                                                    params['appPay'] = 'APP';
                                                    _this.pushByName(page, params, { relativeTo: _this.route });
                                                }
                                            });
                                        }
                                        else if (this_4.browserService.isAlipay() && gateway !== 'eft-hk') {
                                            buttons.push({
                                                icon: 'payment-alipay',
                                                text: this_4.t.instant('payments.alipayCN'),
                                                cssClass: key + ' pay-button',
                                                handler: function () {
                                                    var page = 'EftPaymentPage';
                                                    params['payment'] = methods[key];
                                                    params['wallet'] = 'CN';
                                                    params['appPay'] = 'APP';
                                                    _this.pushByName(page, params, { relativeTo: _this.route });
                                                }
                                            });
                                        }
                                        else if (!this_4.browserService.isAlipayHK() && !this_4.browserService.isAlipay()) {
                                            if (gateway === 'eft' || gateway === 'eft-hk') {
                                                buttons.push({
                                                    icon: 'payment-alipay',
                                                    text: this_4.t.instant('payments.alipayHK'),
                                                    cssClass: key + ' pay-button',
                                                    handler: function () {
                                                        // var isEft = methods[key]["gateway"] === "eft";
                                                        var page = 'EftPaymentPage';
                                                        params['payment'] = methods[key];
                                                        params['wallet'] = 'HK';
                                                        params['appPay'] = 'APP';
                                                        _this.pushByName(page, params, { relativeTo: _this.route });
                                                    }
                                                });
                                            }
                                            if (gateway === 'eft' || gateway === 'eft-cn') {
                                                buttons.push({
                                                    icon: 'payment-alipay',
                                                    text: this_4.t.instant('payments.alipayCN'),
                                                    cssClass: key + ' pay-button',
                                                    handler: function () {
                                                        // var isEft = methods[key]["gateway"] === "eft";
                                                        var page = 'EftPaymentPage';
                                                        params['payment'] = methods[key];
                                                        params['wallet'] = 'CN';
                                                        params['appPay'] = 'APP';
                                                        _this.pushByName(page, params, { relativeTo: _this.route });
                                                    }
                                                });
                                            }
                                        }
                                    }
                                }
                                else {
                                    buttons.push({
                                        icon: 'payment-alipay',
                                        text: methods[key]['gateway'].indexOf('hk') === -1 ? this_4.t.instant('payments.alipayCN') : this_4.t.instant('payments.alipayHK'),
                                        cssClass: key + ' pay-button',
                                        handler: function () {
                                            // var isEft = methods[key]["gateway"] === "eft";
                                            // var isStripe = methods[key]["gateway"] === "stripe";
                                            var page = 'AlipayPaymentPage'; // 'AlipayPaymentPage'; // isStripe ? AlipayPaymentPage : ValootWechatPayPaymentPage;
                                            if (methods[key]['gateway'].indexOf('seitopay') !== -1) {
                                                page = 'RedirectPayment';
                                            }
                                            else if (methods[key]['gateway'].indexOf('stripe') !== -1) {
                                                page = 'RedirectPayment';
                                            }
                                            params['payment'] = methods[key];
                                            _this.pushByName(page, params, { relativeTo: _this.route });
                                        }
                                    });
                                }
                            }
                            else if (key === 'alipay-app-hk') {
                                buttons.push({
                                    icon: 'payment-alipay',
                                    text: this_4.t.instant('payments.alipayHK'),
                                    cssClass: key + ' pay-button',
                                    handler: function () {
                                        var page = 'AlipayPaymentPage';
                                        params['payment'] = methods[key];
                                        _this.pushByName(page, params, { relativeTo: _this.route });
                                    }
                                });
                            }
                            else if (key === 'alipay-app-cn') {
                                buttons.push({
                                    icon: 'payment-alipay',
                                    text: this_4.t.instant('payments.alipayCN'),
                                    cssClass: key + ' pay-button',
                                    handler: function () {
                                        var page = 'AlipayPaymentPage';
                                        params['payment'] = methods[key];
                                        _this.pushByName(page, params, { relativeTo: _this.route });
                                    }
                                });
                            }
                            else if (key === 'wechat') {
                                buttons.push({
                                    icon: 'payment-wechat',
                                    text: this_4.t.instant('payments.wechat'),
                                    cssClass: key + ' pay-button',
                                    handler: function () {
                                        var method = methods[key];
                                        var gateway = method['gateway'];
                                        console.log('wechat clicked', method);
                                        var page = null;
                                        var isEft = gateway.startsWith('eft');
                                        var isQFPay = gateway.startsWith('qfpay');
                                        if (isEft || isQFPay) {
                                            if (gateway.startsWith('eft-hk')) {
                                                page = 'WechatOpenPaymentPage';
                                            }
                                            else {
                                                page = 'EftPaymentPage';
                                            }
                                        }
                                        else {
                                            if (gateway === 'seitopay') {
                                                page = 'RedirectPayment';
                                            }
                                            if (method.sub === 'open') {
                                                page = 'WechatOpenPaymentPage';
                                            }
                                            else if (method.sub === 'mini') {
                                                page = 'WechatOpenPaymentPage';
                                            }
                                        }
                                        if (page) {
                                            params['payment'] = methods[key];
                                            _this.pushByName(page, params, { relativeTo: _this.route });
                                        }
                                    }
                                });
                            }
                            else if (key === 'wechat-mini') {
                                buttons.push({
                                    text: this_4.t.instant('payments.wechat'),
                                    handler: function () {
                                        var method = methods[key];
                                        // var gateway = method["gateway"];
                                        console.log('wechat clicked', method);
                                        var page = null;
                                        if (method.sub === 'mini') {
                                            page = 'WechatOpenPaymentPage';
                                        }
                                        if (page) {
                                            params['payment'] = methods[key];
                                            _this.pushByName(page, params, { relativeTo: _this.route });
                                        }
                                    }
                                });
                            }
                            else if (key === 'wechat-app.eft-cn' || key === 'wechat-app.eft-hk') {
                                buttons.push({
                                    text: this_4.t.instant('payments.wechat'),
                                    cssClass: key + ' pay-button',
                                    handler: function () {
                                        var page = 'WechatAppPaymentPage';
                                        params['payment'] = methods[key];
                                        _this.pushByName(page, params, { relativeTo: _this.route });
                                    }
                                });
                            }
                            else if (key === 'oepay') {
                                buttons.push({
                                    text: this_4.t.instant('payments.oepay'),
                                    cssClass: key + ' pay-button',
                                    handler: function () {
                                        params['payment'] = methods[key];
                                        _this.pushByName('OepayPaymentPage', params, { relativeTo: _this.route });
                                    }
                                });
                            }
                            else if (key === 'netspay') {
                                buttons.push({
                                    text: 'NETSPay',
                                    cssClass: key + ' pay-button',
                                    handler: function () {
                                        if (!_this.BKMember || !_this.BKMember.email || !_this.BKMember.phone) {
                                            _this.getBKMember(function () {
                                                _this.netsPayHandling(methods[key]);
                                            });
                                        }
                                        else {
                                            _this.netsPayHandling(methods[key]);
                                        }
                                    }
                                });
                            }
                            else if (key === 'cash') {
                                console.log('value', methods[key]);
                                buttons.push({
                                    icon: 'payment-cashpay',
                                    text: this_4.t.instant('payments.cash'),
                                    cssClass: key + ' icon-cashpay pay-button',
                                    handler: function () {
                                        _this.loading(true);
                                        _this.orderService.postOrderWithPaymentObject(_this.orderManager.getOrder(), methods[key]).subscribe(function (order) {
                                            _this.loading(false);
                                            console.log('checking order', order);
                                            _this.popToRoot().then(function (data) {
                                                if (methods[key]['gateway'] === 'cash' || methods[key]['gateway'] === 'pos') {
                                                    // this.pushByName('OrderQrCodePage', {
                                                    _this.pushByName('QrCodePage', {
                                                        qrData: order['data']['qrcode'],
                                                        order: order['data'],
                                                        ifSessionId: false
                                                    }).then(function () {
                                                        _this.orderService.clear();
                                                        _this.orderManager.clear();
                                                    });
                                                }
                                                // for case flow (浸會)
                                                if (methods[key]['gateway'] === 'delaypayment') {
                                                    var qrdata = (order && order['data'] && order['data']['extra'] && order['data']['extra']['posBackendId']);
                                                    if (qrdata) {
                                                        qrdata = 'TMPOR' + qrdata;
                                                    }
                                                    // this.pushByName('OrderQrCodePage', {
                                                    _this.pushByName('QrCodePage', {
                                                        qrData: qrdata,
                                                        order: order['data'],
                                                        ifSessionId: false
                                                    }).then(function () {
                                                        _this.orderService.clear();
                                                        _this.orderManager.clear();
                                                    });
                                                }
                                            });
                                            // this.popToRoot();
                                            // let qrdata : string = (order && order["data"] && order["data"]["extra"] && order["data"]["extra"]["posBackendId"])
                                            // if (qrdata) qrdata = "TMPOR" + qrdata;
                                            // this.pushByName(OrderQrCodePage, { order: order, qrData: qrdata }).then(() => {
                                            //     this.orderService.clear();
                                            //     if (this.navParams.get("fromSplash")) {
                                            //         this.orderManager.clear();
                                            //     }
                                            // });
                                            // for case flow
                                        }, function (err) {
                                            _this.loading(false);
                                            _this.showError(err);
                                            if (err.status === 464) {
                                                _this.couponErrorHandle(true, function (cb) {
                                                    _this.orderManager.setDiscounts(_this.orderService.store.menu);
                                                    _this.applyPromotion(false);
                                                    _this.orderManager.calculate();
                                                });
                                            }
                                        });
                                    }
                                });
                            }
                            else if (key === 'delay' && methods[key]['label']) { // && (this.orderManager.mode !== 'takeaway')
                                buttons.push({
                                    text: methods[key]['label'],
                                    cssClass: key + ' pay-button',
                                    handler: function () {
                                        _this.loading(true);
                                        _this.orderService.postOrderWithPaymentObject(_this.orderManager.getOrder(), methods[key]).subscribe(function (order) {
                                            _this.loading(false);
                                            _this.popToRoot().then(function (data) {
                                                var doNotPaid = methods[key]['doNotPaid'];
                                                if (!doNotPaid) {
                                                    // this.popToRoot();
                                                    _this.pushByName('OrderStatusPage', {
                                                        status: 'success',
                                                        storeId: _this.orderManager.store.id,
                                                        spot: _this.orderService.spot,
                                                        key: _this.orderService.session,
                                                        order: order['data'],
                                                        hideHistory: false,
                                                        delayPayment: true
                                                    }).then(function () {
                                                        _this.orderService.clear();
                                                        _this.orderManager.clear();
                                                    });
                                                    return;
                                                }
                                                // this.popToRoot();
                                                var qrdata = (order && order['data'] && order['data']['qrcode']);
                                                // if (qrdata) {
                                                //     qrdata = 'TMPOR' + qrdata;
                                                // }
                                                // this.pushByName('OrderQrCodePage', {order: order, qrData: qrdata}).then(() => {
                                                _this.pushByName('QrCodePage', { order: order['data'], qrData: qrdata }).then(function () {
                                                    _this.orderService.clear();
                                                    _this.orderManager.clear();
                                                });
                                            });
                                            // console.log("order:",order);
                                        }, function (err) {
                                            _this.loading(false);
                                            _this.showError(err);
                                        });
                                    }
                                });
                            }
                            else if (key === 'gopay') {
                                buttons.push({
                                    text: 'GoPay',
                                    handler: function () {
                                        params['payment'] = methods[key];
                                        _this.pushByName('RedirectPayment', params, { relativeTo: _this.route });
                                    }
                                });
                            }
                            else if (key === 'mpayment') {
                                buttons.push({
                                    text: 'MPay',
                                    handler: function () {
                                        params['payment'] = methods[key];
                                        _this.pushByName('RedirectPayment', params, { relativeTo: _this.route });
                                    }
                                });
                            }
                        };
                        this_4 = this;
                        for (key in methods) {
                            _loop_5(key);
                        }
                        if (!(buttons.length > 1)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.actionSheetCtrl.create({
                                header: this.t.instant('global.payment-method'),
                                buttons: buttons
                            })];
                    case 1:
                        actionSheet = _a.sent();
                        actionSheet.present();
                        return [3 /*break*/, 3];
                    case 2:
                        buttons[0].handler();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // TODO cross check store gateway and supported methods
    BaseCartPage.prototype.getPaymentMethods = function (payments) {
        console.log(this.browserService.browser);
        var methods = {};
        for (var _i = 0, payments_1 = payments; _i < payments_1.length; _i++) {
            var payment = payments_1[_i];
            if (payment['id'] && payment['id'].indexOf('-sync-') !== -1) {
                console.log('pos sync payment, ignore', payment);
                continue;
            }
            console.log('checking payment', payments);
            var pos = payment['gateway'] === 'pos';
            if (pos && payment['method'] === 'cash') {
                //
            }
            else if (pos && payment['method'] !== 'delay') {
                continue;
            }
            // if (pos && payment["method"] === "delay" && !payment["label"]) continue;
            var takeaway = this.orderManager.mode === 'takeaway';
            var dinein = this.orderManager.mode === 'dinein';
            var pickup = takeaway || dinein;
            var isWeChat = this.browserService.isWeChat() || this.browserService.isWeChatHK();
            // if(isWeChat && payment["method"] != "wechat") continue;
            var isAlipay = this.browserService.isAlipay() || this.browserService.isAlipayHK();
            // if(isAlipay && payment["method"] != "alipay") continue;
            if (payment['method'] === 'creditcard') {
                methods['creditcard'] = payment;
            }
            if (payment['method'] === 'netspay' && pickup && !isWeChat && !isAlipay) {
                methods['netspay'] = payment;
            }
            if (payment['method'] === 'session') {
                methods['session'] = payment;
            }
            if (payment['method'] === 'gopay') {
                methods['gopay'] = payment;
            }
            if (payment['method'] === 'mpayment') {
                methods['mpayment'] = payment;
            }
            // if (payment['method'] === 'point') {
            //     methods['session'] = payment;
            // }
            if (payment['method'] === 'wechat' && !isAlipay) {
                var subMethod = payment['sub'];
                if (subMethod === 'mini') {
                    if (this.browserService.isWeChatMiniProgramWebview()) {
                        methods['wechat-mini'] = payment;
                    }
                    else {
                        break;
                    }
                }
                var canAdd = (this.orderService.isStaff && subMethod === 'scan') || (!this.orderService.isStaff && subMethod !== 'scan' && isWeChat);
                if (canAdd) {
                    methods['wechat'] = payment;
                }
            }
            else if (payment['method'] === 'alipay' && !isWeChat) {
                var subMethod = payment['sub'];
                if ((this.orderService.isStaff && subMethod === 'scan') || (!this.orderService.isStaff && subMethod !== 'scan')) {
                    // new ,for alipay method but, gateway is eft-cn / eft-hk
                    var key = 'alipay.' + payment['gateway'];
                    methods[key] = payment;
                }
            }
            if (payment['method'] === 'alipay-app' && this.sdkAlipayHKService.isAvailable() && !isWeChat) {
                if (payment['gateway'] === 'alipay-cn') {
                    methods['alipay-app-cn'] = payment;
                }
                else if (payment['gateway'] === 'alipay-hk') {
                    methods['alipay-app-hk'] = payment;
                }
            }
            if (payment['method'] === 'wechat-app' && this.sdkWeChatPayService.isAvailable()) {
                if (payment['gateway'] === 'eft-cn') {
                    methods['wechat-app.eft-cn'] = payment;
                }
                else if (payment['gateway'] === 'eft-hk') {
                    methods['wechat-app.eft-hk'] = payment;
                }
            }
            if (payment['method'] === 'oepay' && !isAlipay && !isWeChat) {
                methods['oepay'] = payment;
            }
            if (((this.paymentService.canApplePay() || this.sdkApplePayService.isAvailable()) && !isWeChat && !isAlipay) && payment['method'] === 'apple') {
                methods['apple'] = payment;
            }
            else if ((this.browserService.isSupportNativeGooglePay() || (this.paymentService.canAndroidPay()) && !isWeChat && !isAlipay) && payment['method'] === 'google') {
                console.log('is android pay', payment);
                methods['android'] = payment;
            }
            if (payment['method'] === 'cash') {
                var canAdd = !this.orderManager.store.brand.hasFeature('staff-cash') || (this.orderService.isStaff && this.orderManager.store.brand.hasFeature('staff-cash'));
                if (canAdd) {
                    methods['cash'] = payment;
                }
            }
            if (payment['method'] === 'delaypayment' || payment['method'] === 'delay') {
                methods['delay'] = payment;
            }
        }
        console.log('pay methods', methods);
        return methods;
    };
    BaseCartPage.prototype.settingUpSelling = function () {
        this.upSellItemCategory = this.menuManager.getAvailableRecommendation(this.orderManager.store, new Date().getTime(), this.orderManager.mode === 'takeaway');
        if (this.orderManager.store.menu.recommendation) {
            this.upSellItemCategory = this.orderManager.store.menu.recommendation;
            this.upSellItemGroup = this.upSellItemCategory.groups[0];
            this.upSellItems = this.upSellItemGroup ? this.upSellItemGroup.items : [];
            this.hasRecommendation = this.upSellItems.length > 0;
        }
        else {
            this.hasRecommendation = false;
        }
    };
    BaseCartPage.prototype.loginReminderAlert = function () {
        return __awaiter(this, void 0, void 0, function () {
            var alert;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.alertController.create({
                            header: 'Login to earn',
                            buttons: [
                                {
                                    text: 'Order as guest',
                                    role: 'cancel',
                                    handler: function (data) {
                                        _this.paymentHandling();
                                    }
                                },
                                {
                                    text: 'Go to Login',
                                    handler: function (data) {
                                        _this.popLogin();
                                    }
                                }
                            ]
                        })];
                    case 1:
                        alert = _a.sent();
                        alert.present();
                        return [2 /*return*/];
                }
            });
        });
    };
    BaseCartPage.prototype.onOrderChanged = function (order) {
        if (!order) {
            return;
        }
        this.selectedPoint = 0;
        console.log('on order change', order);
        this.setPointSelection();
    };
    BaseCartPage.prototype.getCourtCountry = function () {
        var country = this.orderManager.store.country;
        return country;
    };
    BaseCartPage.prototype.getVariationModalDismissToPageAndCss = function () {
        var cssClass = 'modal-largescreen set-list-view combo-modal-backdrop-dismiss';
        var navComponent = 'LoginPage';
        return { navComponent: navComponent, cssClass: cssClass };
    };
    return BaseCartPage;
}(MobileBasePage));
export { BaseCartPage };
